import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  deliveryInfo: {
    id: 'pd.delivery.info',
    defaultMessage: 'Způsoby dopravy',
  },
});
